import { ref, computed } from 'vue'
import axios from 'axios'

const API_BASE = 'https://mpapi.premside.uz'

// Глобальное состояние прав
const userPermissions = ref([])
const allPermissions = ref([])
const permissionsLoaded = ref(false)

export function usePermissions() {
  /**
   * Загрузить права текущего пользователя
   */
  const loadUserPermissions = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/auth/permissions`)
      userPermissions.value = response.data.permissions || []
      permissionsLoaded.value = true
      console.log('✅ Права пользователя загружены:', userPermissions.value)
      return userPermissions.value
    } catch (error) {
      console.error('❌ Ошибка загрузки прав пользователя:', error)
      userPermissions.value = []
      return []
    }
  }

  /**
   * Загрузить все доступные права (для админки)
   */
  const loadAllPermissions = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/admin/permissions`)
      allPermissions.value = response.data.permissions || []
      console.log('✅ Все права загружены:', allPermissions.value.length)
      return allPermissions.value
    } catch (error) {
      console.error('❌ Ошибка загрузки всех прав:', error)
      allPermissions.value = []
      return []
    }
  }

  /**
   * Проверить наличие права
   */
  const hasPermission = (permissionName) => {
    // Проверяем, является ли пользователь root admin
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    if (user.is_root_admin) {
      // Root admin имеет ВСЕ права
      return true
    }

    // Если права еще не загружены, показываем все (безопасный режим)
    // Альтернатива: можно вернуть false и показать лоадер
    if (!permissionsLoaded.value) {
      return true
    }

    // Проверяем наличие права в массиве
    return userPermissions.value.includes(permissionName)
  }

  /**
   * Проверить наличие хотя бы одного из прав
   */
  const hasAnyPermission = (...permissionNames) => {
    return permissionNames.some(perm => hasPermission(perm))
  }

  /**
   * Проверить наличие всех прав
   */
  const hasAllPermissions = (...permissionNames) => {
    return permissionNames.every(perm => hasPermission(perm))
  }

  /**
   * Получить права по категории
   */
  const getPermissionsByCategory = (category) => {
    return allPermissions.value.filter(p => p.category === category)
  }

  // Computed свойства для удобства
  const pagePermissions = computed(() =>
    allPermissions.value.filter(p => p.category === 'page')
  )

  const actionPermissions = computed(() =>
    allPermissions.value.filter(p => p.category === 'action')
  )

  const dataPermissions = computed(() =>
    allPermissions.value.filter(p => p.category === 'data')
  )

  /**
   * Очистить права (при выходе)
   */
  const clearPermissions = () => {
    userPermissions.value = []
    allPermissions.value = []
    permissionsLoaded.value = false
  }

  return {
    // Состояние
    userPermissions,
    allPermissions,
    permissionsLoaded,

    // Методы
    loadUserPermissions,
    loadAllPermissions,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    getPermissionsByCategory,
    clearPermissions,

    // Computed
    pagePermissions,
    actionPermissions,
    dataPermissions
  }
}
